import React from 'react';
import { useTranslation } from 'react-i18next';

import '../../scss/style.scss';

import { ReactComponent as DotPatterIcon } from '../../../../assets/icons/dot-pattern.svg';
import { ReactComponent as FluidPatterIcon } from '../../../../assets/icons/fluid-pattern.svg';
import { ReactComponent as InnerEyeCircle } from '../../../../assets/icons/inner-eye-circle.svg';
import { ReactComponent as InnerEyeRound } from '../../../../assets/icons/inner-eye-round.svg';
import { ReactComponent as InnerEyeSquare } from '../../../../assets/icons/inner-eye-square.svg';
import { ReactComponent as InnerEye } from '../../../../assets/icons/inner-eye.svg';
import { ReactComponent as OuterEyeCircle } from '../../../../assets/icons/outer-eye-circle.svg';
import { ReactComponent as OuterEyeRound } from '../../../../assets/icons/outer-eye-round.svg';
import { ReactComponent as OuterEyeSquare } from '../../../../assets/icons/outer-eye-square.svg';
import { ReactComponent as OuterEye } from '../../../../assets/icons/outer-eye.svg';
import { ReactComponent as QRPatternIcon } from '../../../../assets/icons/qr-pattern.svg';
import { ReactComponent as SquarePatterIcon } from '../../../../assets/icons/square-pattern.svg';

/**
 * QR Style Component
 * @returns
 */
function Style({ setQrValues }: any) {
  const { t } = useTranslation('qrCode');

  const menus = [
    {
      id: 1,
      icon: <QRPatternIcon />,
      label: t('patternStyle'),
      pattern: [
        {
          id: 1,
          icon: <SquarePatterIcon />,
          label: t('square'),
          location: 'qrstyle',
          value: 'squares',
        },
        {
          id: 2,
          icon: <FluidPatterIcon />,
          label: t('fluid'),
          location: 'qrstyle',
          value: 'fluid',
        },
        {
          id: 3,
          icon: <DotPatterIcon />,
          label: t('dot'),
          location: 'qrstyle',
          value: 'dots',
        },
      ],
    },
    {
      id: 2,
      icon: <InnerEye />,
      label: t('patternStyle'),
      pattern: [
        {
          id: 1,
          icon: <InnerEyeSquare style={{ color: 'var(--primary-color)' }}/>,
          label: t('square'),
          location: 'innerEye',
          value: 0,
        },
        {
          id: 2,
          icon: <InnerEyeRound style={{ color: 'var(--primary-color)' }}/>,
          label: t('roundedSquare'),
          location: 'innerEye',
          value: 3,
        },
        {
          id: 3,
          icon: <InnerEyeCircle  style={{ color: 'var(--primary-color)' }}/>,
          label: t('circle'),
          location: 'innerEye',
          value: 10,
        },
      ],
    },
    {
      id: 3,
      icon: <OuterEye />,
      label: t('patternStyle'),
      pattern: [
        {
          id: 1,
          icon: <OuterEyeSquare style={{ color: 'var(--primary-color)' }}/>,
          label: t('square'),
          location: 'outerEye',
          value: 0,
        },
        {
          id: 2,
          icon: <OuterEyeRound style={{ color: 'var(--primary-color)' }}/>,
          label: t('roundedSquare'),
          location: 'outerEye',
          value: 10,
        },
        {
          id: 3,
          icon: <OuterEyeCircle style={{ color: 'var(--primary-color)' }}/>,
          label: t('circle'),
          location: 'outerEye',
          value: 20,
        },
      ],
    },
  ];

  /**
   * Handling Style Selection
   * @param event
   */
  const handleSelect = (value: string | number, location: string) => {
    setQrValues((previous: any) => {
      return {
        ...previous,
        [location]: value,
      };
    });
  };

  return (
    <div className="style-wrap">
      {menus.map((menu) => (
        <div className="style-menu" key={menu.id}>
          <div className="style-menu-header">
            {menu.icon}
            <span>{menu.label}</span>
          </div>
          <div className="style-menu-selection">
            {menu.pattern.map((pattern) => (
              <div
                role="presentation"
                onClick={() => handleSelect(pattern.value, pattern.location)}
                className="style-pattern"
                key={pattern.id}>
                {pattern.icon}
                <span>{pattern.label}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Style;
